// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1N-yY","fullSize":"styles_fullSize__3yjN7","reject":"styles_reject__1lVv5","rounded":"styles_rounded__3dQ-O","default":"styles_default__2jmnh"};